import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Header from './components/layout/Header';
import Sidebar from './components/layout/Sidebar';
import DashboardPage from './pages/Dashboard/DashboardPage';
import AssortmentPage from './pages/AssortmentPage/AssortmentPage';
import OrdersPage from './pages/Orders/OrdersPage';
import SupplyChainPage from './pages/SupplyChain/SupplyChainPage';
import InventoryHealthPage from './pages/InventoryHealth/InventoryHealthPage';
import ReportsPage from './pages/ReportsPage/ReportsPage';
import ReportsListPage from './pages/ReportsPage/ReportsListPage/ReportsListPage';
import ReportsLandingPage from './pages/ReportsPage/ReportsLandingPage/ReportsLandingPage';
import NotificationsPage from './pages/Notifications/NotificationsPage';
import LoginPage from './pages/Login/LoginPage';
import DistributionPage from './pages/DistributionPage/DistributionPage';
import BranchDistributionPage from './pages/DistributionPage/BranchDistributionPage/BranchDistributionPage';
import PromoCalendarPage from './pages/PromoCalendar/PromoCalendarPage';
import { ProtectedRoute, PermissionRoute } from './components/auth/ProtectedRoute';
import { useAuth } from './contexts/AuthContext';
import { SidebarProvider } from './contexts/SidebarContext';

import { ReactComponent as DashboardIcon } from '../src/assets/icons/dashboard-icon.svg';
import { ReactComponent as DpReportIcon } from './assets/icons/dp-report-icon.svg';
import { ReactComponent as AssortmentIcon } from './assets/icons/assortment-icon.svg';
import { ReactComponent as SupplyChainIcon } from './assets/icons/supply-chain-icon.svg';
import { ReactComponent as InventoryIcon } from './assets/icons/inventory-icon.svg';
import { ReactComponent as OrdersIcon } from './assets/icons/orders-icon.svg';
import { ReactComponent as CalendarIcon } from './assets/icons/calendar-icon.svg';
// import { ReactComponent as NotificationsIcon } from './assets/icons/notifications-icon.svg';
import { ReactComponent as ExitIcon } from './assets/icons/exit-icon.svg';
import { ReactComponent as DistributionIcon } from './assets/icons/distribution-icon.svg';

function AppContent() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { logout, userInfo } = useAuth();

  const p = userInfo || {};

  const menuItems = [
    { id: 'dashboard', label: 'Дашборд', icon: DashboardIcon, path: '/dashboard', disabled: !p.isReportsCreated },
    { id: 'reports', label: 'ДП отчет', icon: DpReportIcon, path: '/reports', disabled: !p.isOrdersCreated },
    { id: 'supply-chain', label: 'Заказ', icon: SupplyChainIcon, path: '/supply-chain', disabled: !p.isReportsCreated },
    { id: 'orders', label: 'Приходы', icon: OrdersIcon, path: '/orders', disabled: !p.isAssortmentCreated },
    { id: 'distribution', label: 'Перемещение', icon: DistributionIcon, path: '/distribution', disabled: !p.isReportsCreated },
    { id: 'inventory', label: 'Индекс здоровья', icon: InventoryIcon, path: '/inventory-health', disabled: !p.isReportsCreated },
    { id: 'promo-calendar', label: 'Промо-календарь', icon: CalendarIcon, path: '/promo-calendar', disabled: !p.isReportsCreated },
    { id: 'assortment', label: 'Вводные', icon: AssortmentIcon, path: '/assortment', disabled: false },
    // { id: 'notifications', label: 'Уведомления', icon: NotificationsIcon, path: '/notifications' },
    { id: 'exit', label: 'Выйти', icon: ExitIcon, path: '/', onClick: logout },
  ];

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <SidebarProvider sidebarOpen={sidebarOpen}>
            <div className="app-container">
              <Header sidebarOpen={sidebarOpen} onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

              <div className="main-layout">
                <Sidebar
                  menuItems={menuItems}
                  sidebarOpen={sidebarOpen}
                  onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
                />

                <main className="main-content">
                  <Routes>
                    <Route path="/dashboard" element={<PermissionRoute allowed={!!p.isReportsCreated}><DashboardPage /></PermissionRoute>} />
                    <Route path="/assortment" element={<AssortmentPage />} />
                    <Route path="/orders" element={<PermissionRoute allowed={!!p.isAssortmentCreated}><OrdersPage /></PermissionRoute>} />
                    <Route path="/supply-chain" element={<PermissionRoute allowed={!!p.isReportsCreated}><SupplyChainPage /></PermissionRoute>} />
                    <Route path="/inventory-health" element={<PermissionRoute allowed={!!p.isReportsCreated}><InventoryHealthPage /></PermissionRoute>} />
                    <Route path="/reports" element={<PermissionRoute allowed={!!p.isOrdersCreated}><ReportsLandingPage /></PermissionRoute>} />
                    <Route path="/reports/list" element={<PermissionRoute allowed={!!p.isOrdersCreated}><ReportsListPage /></PermissionRoute>} />
                    <Route path="/reports/:reportId" element={<PermissionRoute allowed={!!p.isOrdersCreated}><ReportsPage /></PermissionRoute>} />
                    <Route path="/notifications" element={<NotificationsPage />} />
                    <Route path="/distribution" element={<PermissionRoute allowed={!!p.isReportsCreated}><DistributionPage /></PermissionRoute>} />
                    <Route path="/distribution/branch" element={<PermissionRoute allowed={!!p.isReportsCreated}><BranchDistributionPage /></PermissionRoute>} />
                    <Route path="/promo-calendar" element={<PermissionRoute allowed={!!p.isReportsCreated}><PromoCalendarPage /></PermissionRoute>} />

                    <Route path="/" element={<Navigate to="/assortment" replace />} />
                    <Route path="*" element={<Navigate to="/assortment" replace />} />
                  </Routes>
                </main>
              </div>
            </div>
            </SidebarProvider>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return <AppContent />;
}
